/**
 * 会社の単位の一覧（#164、docs/66）。GET /units（だれでも読める）。単位の欄の候補（components/UnitInput.tsx）と設定の画面（pages/SettingsUnits.tsx）が同じ控えを使う
 */
import type { CompanyUnitList } from "@genbaryoku/contract";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api.js";

export const UNITS_KEY = ["units"] as const;

export function useUnitList() {
  return useQuery({ queryKey: UNITS_KEY, queryFn: () => api<CompanyUnitList>("GET", "/units"), staleTime: 60_000 });
}

/** 単位の名前（並び順）。読み込み中は空 */
export function useUnitNames(): string[] {
  return (useUnitList().data?.items ?? []).map((x) => x.name);
}
